import { Requester } from './Requester';
import { ILoanRecord, IManifest } from '../types';

export const GetManifestLoanById = async ({
    loanId,
    manifest
}: {
    loanId: string;
    manifest: string[];
}): Promise<IManifest | null> => {
    const stringManifest = JSON.stringify(manifest);

    try {
        const response = await Requester<IManifest>({
            // port: '8080',
            path: `loans/${loanId}?manifest=${window.btoa(stringManifest)}`,
            method: 'GET'
        });

        return response ? (response as IManifest) : null;
    } catch (e) {
        console.error('Get manifest loan request failed');
        return Promise.reject(e);
    }
};
